import { DocsVerificationStatusEnum, ManualFieldNamesEnum } from '@models/enums';

export const isVerificationNotCompleted = (status: DocsVerificationStatusEnum) =>
    status === DocsVerificationStatusEnum.PENDING ||
    status === DocsVerificationStatusEnum.IN_PROGRESS ||
    status === DocsVerificationStatusEnum.INITIAL;

export const getManualFieldName = (name: string) => {
    let label = name;
    let placeholder = '';

    switch (name) {
        case ManualFieldNamesEnum.FULL_NAME:
            label = 'common.fullName';
            placeholder = 'docVerificationWizard.personalDataForm.fullNamePlaceholder';
            break;
        case ManualFieldNamesEnum.EMAIL:
            label = 'common.email';
            break;
        case ManualFieldNamesEnum.PHONE:
            label = 'common.phone';
            break;
        case ManualFieldNamesEnum.ADDRESS:
            label = 'common.address';
            break;
        case ManualFieldNamesEnum.DOB:
            label = 'common.dateOfBirth';
            break;
        case ManualFieldNamesEnum.GENDER:
            label = 'common.gender';
            break;
        case ManualFieldNamesEnum.CITIZENSHIP:
            label = 'common.citizenship';
            break;
        case ManualFieldNamesEnum.COUNTRY:
            label = 'common.country';
            break;
        default:
            label = name;
    }

    return {
        label,
        placeholder,
    };
};
